import { FC, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../modules/auth'
import { ID, WithChildren } from '../../../_metronic/helpers'


type AppPageType = 'application' | 'certificate' | 'dlmApplication' | 'dlmDOC' | 'dlmROI' | 'siteInspection' | 'company' | 'siteApplication';

const APPLICANT_PAGE_LINKS: Record<AppPageType, string> = {
  application : 'company/view-application',
  certificate : 'company/view-certificate',
  dlmApplication: 'company/doclabel/application-view',
  dlmDOC: 'company/doclabel/doc-view',
  dlmROI: 'company/doclabel/roi-view',
  siteInspection: 'company/doclabel/application-view',
  siteApplication: 'company/doclabel/application-view',
  company: ''
}

const USER_PAGE_LINKS: Record<AppPageType, string> = { 
  application : 'setsco/review-application',
  certificate : 'setsco/view-certificate',
  company: 'setsco/view-company',
  dlmApplication: 'setsco/doclabel-management/application-view',
  dlmDOC: 'setsco/doclabel-management/doc-view',
  dlmROI: 'setsco/doclabel-management/roi-view',
  siteInspection: 'setsco/doclabel-management/siteinspection-view',
  siteApplication: 'setsco/doclabel-management/application-view',
}   

type Props = {
  id: ID      
  pageType: AppPageType
  suffix?: string
  target?: string
}

const PageViewLink: FC<Props & WithChildren> = ({id, target, pageType, suffix = '', children}) => {

  const { currentUser } = useAuth();

  const link = useMemo(() => {
    
    if (! (currentUser && id && pageType)) { 
      return null;
    }

    const basepath = (currentUser.isSetsco) ? USER_PAGE_LINKS[pageType] : APPLICANT_PAGE_LINKS[pageType];
    
    if (! basepath) return null;

    const _suffix = pageType === 'siteApplication' ? '/labelling' : suffix;

    return `/${basepath}/${id}${_suffix}`;

  }, [currentUser, id, pageType, suffix]);

  if (! link) {
    return null;
  }

  return (
  <Link to={link} className="fs-8" target={target} >
    {children}
  </Link>
  )    
}

export {PageViewLink}
